'use client';

import React, { HTMLAttributes } from 'react';
import { getFilePath } from '@/utils';

interface TeamLabelProps extends HTMLAttributes<HTMLDivElement> {
  propsTeamName: string | undefined;
  propsColorA: string | undefined;
  propsColorB: string | undefined;
  propsTeamEmblem?: string;
}

/**
 * チーム名ラベル
 * @param param0
 * @returns
 */
const TeamLabel: React.FC<TeamLabelProps> = ({
  propsTeamName,
  propsColorA,
  propsColorB,
  className,
  propsTeamEmblem
}) => {
  const defaultClassName = 'inline-flex items-center w-fit text-xs font-footballlog italic rounded px-2 py-1';

  return (
    <>
      {propsTeamName && (
        <>
          <span
            className={`${defaultClassName} ${className || ''}`}
            style={{
              border: `solid 1px ${propsColorA}`,
              background: `${propsColorA}`,
              color: `${propsColorB}`
            }}>
            {propsTeamEmblem ? (
              // 画像の高さがテキストの高さに比例して調整
              <img
                src={getFilePath(propsTeamEmblem)}
                alt="teamEmblem"
                className="me-1 object-fit object-fit h-auto"
                style={{ maxHeight: '1em' }}
              />
            ) : (
              <svg
                className="me-1 w-auto h-auto"
                style={{ maxHeight: '1em' }}
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24">
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 20a16.405 16.405 0 0 1-5.092-5.804A16.694 16.694 0 0 1 5 6.666L12 4l7 2.667a16.695 16.695 0 0 1-1.908 7.529A16.406 16.406 0 0 1 12 20Z"
                />
              </svg>
            )}
            {propsTeamName}
          </span>
        </>
      )}
    </>
  );
};

export default TeamLabel;
